import { IExternalDirectoryRecord } from "./externalDirectory/types";
import { ITeamsRecord } from "./teams/types";

export enum DirectorySourceTypes {
    TEAMS = "teams",
    EXTERNAL_DIRECTORY = "external-directory",
}

export enum FullProfileViewFieldNames {
    PHONE_NUMBER = "Phone Number",
    EMAIL = "Email",
    OFFICE = "Office",
    DEPRIORITISED = "Deprioritised",
    BLOCKED = "Blocked",
}

export type DirectoryRecordType = IExternalDirectoryRecord | ITeamsRecord;
